import { Player } from "components/Player/Player";
import { useDiscoContent } from "hooks/useDiscoContent";
import { observer } from "mobx-react";
import type React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const TheoryPage: React.FC = observer(() => {
  const { subchapterTheory, fetchSubchapterTheory, loading } = useDiscoContent() as {
    // biome-ignore lint/suspicious/noExplicitAny: Player dont have types for its dynamic content structure
    subchapterTheory: any;
    fetchSubchapterTheory: (packageId: string, chapterId: string, subchapterId: string) => void;
    loading: boolean;
  };
  const { packageId, chapterId, subchapterId } = useParams<{
    packageId: string;
    chapterId: string;
    subchapterId: string;
  }>();

  useEffect(() => {
    if (packageId && chapterId && subchapterId) {
      fetchSubchapterTheory(packageId, chapterId, subchapterId);
    }
  }, [packageId, chapterId, subchapterId, fetchSubchapterTheory]);
  return (
    <div style={{ padding: "20px" }}>
      <h1>Player POC Theory Page</h1>
      <p>This is a proof of concept page to test the theory Player component on hogeschooltaal.</p>

      {loading && <p>Loading theory content...</p>}
      {/* biome-ignore lint/suspicious/noExplicitAny: Player dont have types for its dynamic content structure */}
      {subchapterTheory?.map((theoryBlock: any) => (
        <div key={theoryBlock.title} style={{ marginBottom: "40px" }}>
          <h2>{theoryBlock.title}</h2>
          {theoryBlock.theory && theoryBlock.theory.length > 0 ? (
            <div>
              {theoryBlock.theory.length > 0 &&
                // biome-ignore lint/suspicious/noExplicitAny: Player dont have types for its dynamic content structure
                theoryBlock.theory.map((theory: any) => {
                  // There could be the case where theory.type === "ASSIGNMENT"
                  // In this case this is a question block inside the theory.
                  // Thats why this data is so nested. For this POC we are going to skip this scenario.
                  // For more info check TheoryAndPracticeQuestions component on app-he-stm-web repo
                  return (
                    <Player
                      key={theory.content[0].id}
                      id={theory.content[0].id}
                      data={{ topics: [theory.content] }}
                    />
                  );
                })}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
});
